export const environment = {
  production: false,
  dbName: 'sapore-poll-pwa',
  dbVersion: 5,
  URLAPI: 'https://api-saporeconecta-dev.sapore.com.br/',
  pass: 'S@p0r31992',
};
//ng serve --project=sapore-survey-pwa --host 0.0.0.0 --disable-host-check
